import { FC, useRef } from 'react'
import { TableCellPopupProps } from './Dialogs.d'
import { OverlayPanel } from 'primereact/overlaypanel'
import { Button } from 'react-bootstrap'

const TableCellPopup: FC<TableCellPopupProps> = ({ rowData }) => {
    const op = useRef(null)
    return (
        <div className="flex flex-column align-items-center gap-3">
            <Button
                as="a"
                variant="link"
                size="sm"
                onClick={(e) => op.current.toggle(e)}
            >
                View
            </Button>
            <OverlayPanel
                ref={op}
                showCloseIcon
                closeOnEscape
                dismissable={false}
                className="shadow"
            >
                <span
                    dangerouslySetInnerHTML={{ __html: rowData.text || '' }}
                />
            </OverlayPanel>
        </div>
    )
}

export default TableCellPopup
